import { FC } from 'react';
import { useAppointmentInfo } from '../../../hooks/useAppointmentInfo';
import { useSendFormsStore } from '../../../providers/store';
import { infoModuleContainerStyle, infoModuleStyle, separatorStyle } from './delivery-detail.styles';
import DeliveryOptions from './delivery-options/delivery-options.component';
import { InfoModuleComponent } from './info-module/info-module-component';

export const DeliveryDetailComponent: FC = () => {
  const { appointmentInfo, formOrPacketToSend, fullName } = useSendFormsStore([
    'personId',
    'appointmentInfo',
    'formOrPacketToSend',
    'locationId',
    'fullName',
  ]);
  const { appointmentAt } = useAppointmentInfo();

  return (
    <>
      <InfoModuleComponent title='Recipient' data={fullName} />
      <span css={infoModuleContainerStyle}>
        <div css={infoModuleStyle}>
          <InfoModuleComponent title='Form' data={formOrPacketToSend?.name ? formOrPacketToSend?.name : null} />
        </div>
        {!!appointmentInfo && (
          <div css={infoModuleStyle}>
            <InfoModuleComponent
              title='Appointment'
              data={appointmentAt ? appointmentAt : null}
              additionInfo={appointmentInfo?.pmsType}
              additionData={appointmentInfo?.practitioner}
            />
          </div>
        )}
      </span>
      <hr css={separatorStyle} />
      <DeliveryOptions />
    </>
  );
};
